import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';
import { EditListDetailsForm } from '../../forms';

import css from './RenameListModal.module.css';

// Focused "rename an audience list" modal. Reuses the same name form the
// full EditListPage uses (EditListDetailsForm), so validation and styling
// stay in one place. Wired from CreatorAudiencePage / OrgAudiencePage where
// the underlying update-list duck action already lives.
const RenameListModal = props => {
  const {
    id,
    isOpen,
    onClose,
    list,
    onSubmit,
    inProgress,
    onManageDisableScrolling,
  } = props;

  const handleSubmit = values => {
    if (!list) return undefined;
    return onSubmit(list.id, { name: (values.name || '').trim() });
  };

  return (
    <Modal
      id={id || 'RenameListModal'}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div className={css.root}>
        <h2 className={css.title}>
          <FormattedMessage id="RenameListModal.title" />
        </h2>
        <EditListDetailsForm
          initialValues={{ name: list?.name || '' }}
          onSubmit={handleSubmit}
          inProgress={inProgress}
        />
      </div>
    </Modal>
  );
};

RenameListModal.defaultProps = {
  id: null,
  isOpen: false,
  list: null,
  inProgress: false,
  onManageDisableScrolling: () => {},
};

RenameListModal.propTypes = {
  id: string,
  isOpen: bool,
  onClose: func.isRequired,
  list: object,
  onSubmit: func.isRequired,
  inProgress: bool,
  onManageDisableScrolling: func,
  intl: intlShape.isRequired,
};

export default injectIntl(RenameListModal);
